module.exports = __webpack_public_path__ + "static/media/has-logo-with-padding.9a1ccd77.png";